import { Box, Pagination } from '@mui/material'

type Props = {
  total: number
  rowsPerPage: number
  page: number
  onPageChange: (page: number) => void
}

export const CustomPagination = ({
  total,
  rowsPerPage,
  page,
  onPageChange,
}: Props) => {
  const count = Math.ceil(total / rowsPerPage)
  return (
    <Box display="flex" justifyContent="flex-end">
      <Pagination
        sx={{
          marginTop: '24px',
          '& .Mui-selected': {
            backgroundColor: 'rgb(3, 34, 76) !important',
            color: '#fff !important',
          },
        }}
        color="secondary"
        variant="outlined"
        shape="rounded"
        count={count}
        page={page + 1}
        onChange={(_event, newPage) => onPageChange(newPage - 1)}
      />
    </Box>
  )
}
